﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as accountModel from "~base/Services/API/Account/Model";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (tenantName?: string): string => {
    let uri = "api/account/v1/user/login-info";

    if (tenantName) {
        uri += `?tenantName=${encodeURIComponent(tenantName)}`;
    }

    return uri;
};

const method = "GET";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export interface GetLoginInfoContext {
    tenantName: string;
}

interface GetLoginInfoProps
    extends
        GetLoginInfoContext,
        api.ApiHookBaseProps<
            unknown,
            accountModel.GetLoginInfoResponse,
            unknown
        > {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useGetLoginInfo(
    props: GetLoginInfoProps
): [boolean, (params: GetLoginInfoContext) => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        unknown,
        accountModel.GetLoginInfoResponse,
        unknown
    > = {
        ...props,
        uri: uri(props.tenantName),
        method: method,
    };

    const [loading, invoker] = api.useApi<
        unknown,
        accountModel.GetLoginInfoResponse,
        unknown
    >(apiParams);
    return [
        loading,
        (params: GetLoginInfoContext) => invoker(uri(), undefined),
    ];
}
